import React from 'react';
import { connect } from 'react-redux';

import widgetSelector from 'Selectors/widgetsSelector';

import { deleteWidget, fetchWidget, refreshWidget } from 'Actions/WidgetActions';
import { trackGAEvent } from 'Actions/adsActions';

import WidgetThreadListComponent from 'Components/widgets/WidgetThreadListComponent';
import SvgIcon from 'Components/svg/SvgIcon';
import LoaderCss from 'Components/common/LoaderCssComponent';

import rawToReact from 'Utils/bbcode/RawToReact';

class WidgetContainerComponent extends React.Component {
	constructor( props ) {
		super( props );
		this.widgetShortName = this.props.widgetName.replace( /\s+|\./ig, '_' );
	}

	componentDidMount() {
		this.dispatchRequest( this.props, false );
	}

	componentWillUnmount() {
		this.props.dispatch( deleteWidget( this.widgetShortName ) );
	}

	shouldComponentUpdate( nextProps ) {
		let thisWidget = this.props.widgetState.widgets[ this.widgetShortName ],
			thisWidgetNext = nextProps.widgetState.widgets[ this.widgetShortName ];
		return !!(
			thisWidget &&
			thisWidgetNext && (
				thisWidget.isFetching !== thisWidgetNext.isFetching ||
				thisWidget.beenUpdated !== thisWidgetNext.beenUpdated
			)
		);
	}

	componentWillReceiveProps( nextProps ) {
		let thisWidget = this.props.widgetState.widgets[ this.widgetShortName ],
			thisWidgetNext = nextProps.widgetState.widgets[ this.widgetShortName ];

		if(
			thisWidgetNext &&
			thisWidget &&
			thisWidget.isFetching !== true &&
			typeof thisWidget.refresh !== 'undefined'
		) {
			if( thisWidget.refresh !== thisWidgetNext.refresh ) {
				this.dispatchRequest( this.props, true );
			}
		}
	}

	refreshThisWidget = () => {
		this.props.dispatch( refreshWidget( this.widgetShortName ) );
		this.props.dispatch( trackGAEvent( false, `refresh_Widget-${ this.widgetShortName }`, 'userAction', 'consumption' ) );
	};

	prepareRequest = () => {
		let id = 'new';
		switch( this.props.type ) {
			case 'popularTopics':
				id = 'new_byv';
		}

		return {
			id: id,
			showtopics: null,
			showposts: null,
			page: 1,
			pageSize: 4
		};
	};

	dispatchRequest( props, refresh ) {
		let requestParams = this.prepareRequest( props );
		let cacheBust = refresh ? new Date().getTime() : false;
		this.props.dispatch( fetchWidget( requestParams, this.widgetShortName, this.props.type, cacheBust ) );
	}

	getWidget() {
		let widget = null;
		switch( this.props.type ) {
			case 'activeTopics':
			case 'popularTopics':
				widget = <WidgetThreadListComponent
							widget={ this.props.widgetState.widgets[ this.widgetShortName ] }
							showLast={ true }
						/>;
				break;

			default:
				widget = <div className="widgetSubContainer">
					<p>Widget called: { this.props.widgetName }</p>
					<p>Some text here</p>
					<p>{ rawToReact( 'more text here' ) }</p>
				</div>;
				break;
		}

		return widget;
	}

	render() {
		let thisWidget = this.props.widgetState.widgets[ this.widgetShortName ] || null ;
		let component = thisWidget && thisWidget.isFetching === false ?
			this.getWidget() :
			<LoaderCss containerClass="loaderContainer" />;

		return <div id={ `widget-${ this.widgetShortName }` } className="widget threads">
			<div className="forumGroup">
				{ this.props.widgetName }
				<div className="icon refresh" onClick={ this.refreshThisWidget } ><SvgIcon icon="refresh" size="16px"/></div>
			</div>
			<div className="thread widgetContainer">
				{ component }
			</div>
		</div>;
	}
}

export default connect( widgetSelector )( WidgetContainerComponent );




// WEBPACK FOOTER //
// ./src/components/widgets/WidgetContainerComponent.js